module.exports = __webpack_public_path__ + "static/media/adidas.330a6cd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adidas.svg
// module id = 107
// module chunks = 0